var mentions_default = {
  "mentionPalette": "zFfSu",
  "mention": "fbZ9N",
  "mentionViewer": "DZCZR",
  "mentionSuggestionsEntry": "-vyQX",
  "mentionSuggestionsEntryFocused": "Q8RZ5",
  "mentionSuggestionsEntryText": "_4DzF9",
  "mentionSuggestionsEntryAvatar": "j2IXP",
  "mentionSuggestions": "AIBva",
  "cursorDefault": "hOInR",
  "cursorPointer": "Zu1Ce"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
